<div class="position-relative">
  <input
    class="input-base trailing-icon-padding"
    [class]="{
      'input-large': inputSize() === InputSize.large,
      'input-small': inputSize() === InputSize.small,
    }"
    type="text"
    [class.input-error]="error()"
    [attr.id]="controlId()"
    [value]="value()"
    [disabled]="disabled()"
    [autocomplete]="autocomplete()"
    [attr.inputMode]="'decimal'"
    [placeholder]="placeholder()"
    [maskito]="maskitoOptions"
    (input)="handleInput($event)" />
  <mat-icon
    class="input-trailing-icon"
    [class]="{
      'input-trailing-icon-large': inputSize() === InputSize.large,
      'input-trailing-icon-small': inputSize() === InputSize.small,
    }"
    svgIcon="percent">
  </mat-icon>
</div>
